
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Angers dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Angers certifiée Google Partner, soutient les entreprises angevines pour stimuler leur visibilité et accroître leur clientèle.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Angers dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Angers certifiée Google Partner, soutient les entreprises angevines pour stimuler leur visibilité et accroître leur clientèle.",
        },
      ],
    };
  },
};
